
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";

export function useUpload() {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  const uploadImage = async (file: File, bucketName: string = 'public') => {
    try {
      setIsUploading(true);
      setUploadError(null);

      // Generate a unique filename
      const fileExt = file.name.split('.').pop();
      const fileName = `${crypto.randomUUID()}.${fileExt}`;
      const filePath = `lovable-uploads/${fileName}`;

      // Upload to Supabase storage
      const { data, error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, file);

      if (error) {
        setUploadError(error.message);
        return null;
      }

      // Format the URL in the correct format: "lovable-uploads/filename.ext"
      const publicUrl = `lovable-uploads/${fileName}`;

      // Insert record into lovable_uploads
      const { data: uploadRecord, error: insertError } = await supabase
        .from('lovable_uploads')
        .insert({
          file_name: fileName,
          original_name: file.name,
          url: publicUrl,
          file_type: file.type,
          file_size: file.size
        })
        .select()
        .single();

      if (insertError) {
        setUploadError(insertError.message);
        return null;
      }

      return uploadRecord;
    } catch (err) {
      setUploadError(err instanceof Error ? err.message : 'Upload failed');
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadImage, isUploading, uploadError };
}
